// extracted by mini-css-extract-plugin
module.exports = {"isDelete":"binding-record_isDelete_wpC5V"};